import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {get_Payment_page_visitors} from '../../../store/actions/CommanAction';
import DataTable from 'react-data-table-component';
import Loader from '../Loader/Loader';
import { customStyles } from "../Utility/Utility";


const PaymentPageVisitors = () => {
    const dispatch = useDispatch();
    const Paymenthistory = useSelector((state) => state.feedBackReducer.GetPaymentButNotBuy);

    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [loading, setloading] = useState(false);
   

    useEffect(() => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${yyyy}-${mm}-${dd}`;

        const defaultStartTime = `${formattedToday}`;
        const defaultEndTime = `${formattedToday}`;

        setStartTime(defaultStartTime);
        setEndTime(defaultEndTime);
       
        dispatch(get_Payment_page_visitors(formattedToday, formattedToday,setloading));
    }, [dispatch]);


    const handleSearch = () => {

        const formatDate = (dateTime) => {
            if (!dateTime) return null;
            const date = new Date(dateTime);
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        };

        const formattedStartDate = formatDate(startTime);
        const formattedEndDate = formatDate(endTime);

        const data = {
            FromDate: formattedStartDate,
            Todate: formattedEndDate,
           
        };

        dispatch(get_Payment_page_visitors(data.FromDate, data.Todate,setloading));


    };
   

   


    const columns = [
        {
            name: 'User Name', selector: (row) => row.NickName, sortable: true,
        },
        {
            name: 'Mobile No',
            selector: (row) => row.MobileNo,
            sortable: true,
        },
        {
            name: 'Email', selector: (row) => row.Email, sortable: true,
        },
        {
            name: 'Date',
             selector: (row) => row.CreatedDate,
            //  selector: (row) => new Date(row.CreatedDate).toLocaleDateString(),
             sortable: true,
        },
        

    ];
    return (
        <div>

            <div className="form-group main_card">
                <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Payment Page VisitCustomers</h2>
                <div className="row mt-3">
                    <div className="col-3">
                        <label className="form-label">Start Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <label className="form-label">End Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>
                  <button style={{width:"70px"}} className="btn btn-primary mt-3"   onClick={() => handleSearch()}>
                    Search
                </button>

                </div>

              

                
            </div>


            <div className="col-12 mt-2 main_card">
                {loading ? (
                    <Loader />
                ) : (
                    <DataTable
                        dense
                        data={Paymenthistory || []}
                        columns={columns}
                        selectableRowsHighlight
                        pagination
                        persistTableHead={true}
                         customStyles={customStyles}
                        noDataComponent={"There are no data to display"}
                    />)}
            </div>
        </div>
    );
};
export default PaymentPageVisitors;



